"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { action, observable } from "mobx";
import Panel from "../../Panel/Panel";
import OnClickOutside from "../../../../utils/OnClickOutside";
import { randomString } from "../../../../utils";
import { ChevronDown } from "../../../icons";
import { DropdownContext } from "./DropdownContext";
import { DropdownTheme } from "./DropdownTheme";
export var DropdownSize = /* @__PURE__ */ ((DropdownSize2) => {
  DropdownSize2["Small"] = "small";
  DropdownSize2["Medium"] = "medium";
  DropdownSize2["Large"] = "large";
  return DropdownSize2;
})(DropdownSize || {});
const TabKey = "Tab";
let Dropdown = class extends React.Component {
  constructor(props) {
    super(props);
    this.showingMenu = false;
    this.onKeyUp = (event) => {
      if (event.key == TabKey && !this.showingMenu) {
        this.showDropdown();
      }
    };
    this.onKeyDown = (event) => {
      if (event.key == TabKey) {
        this.hideDropdown();
      }
    };
    this.toggleDropdown = () => {
      if (this.showingMenu) {
        this.hideDropdown();
      } else {
        this.showDropdown();
      }
    };
    this.showDropdown = () => {
      this.showingMenu = true;
      this.onClickOutside.startListening();
    };
    this.hideDropdown = () => {
      this.showingMenu = false;
      this.onClickOutside.stopListening();
    };
    this.hideDropdownFromOutside = () => {
      this.onClickOutside.stopListening();
      setTimeout(() => {
        this.showingMenu = false;
      }, 0);
    };
    this.identifier = `dropdown${randomString()}`;
    const clickSelectors = [`#${this.identifier} .dropdown__button`];
    if (props.remainOpenOnSelect) {
      clickSelectors.push(`#${this.identifier} .dropdown-item`);
    }
    this.onClickOutside = new OnClickOutside(clickSelectors, this.hideDropdownFromOutside);
  }
  render() {
    const { label, size, children, theme = DropdownTheme.Light } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("dropdown", { [`dropdown--dark`]: theme === DropdownTheme.Dark }),
        id: this.identifier
      },
      label && /* @__PURE__ */ React.createElement("div", { className: classNames("dropdown__label", { "dropdown__label--long": this.props.hasLongLabel }) }, label),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames([
            "dropdown__button",
            "center-aligned",
            { "dropdown__button--toggled": this.showingMenu },
            `dropdown__button--${size}`
          ]),
          onClick: this.toggleDropdown,
          onKeyUp: this.onKeyUp,
          onKeyDown: this.onKeyDown,
          tabIndex: 0
        },
        this.renderNameOrPlaceholder(),
        /* @__PURE__ */ React.createElement(ChevronDown, { className: "dropdown__arrow" })
      ),
      this.showingMenu && /* @__PURE__ */ React.createElement(Panel, { className: "dropdown__menu fade-in-down", theme: theme === DropdownTheme.Light ? "light" : "dark" }, /* @__PURE__ */ React.createElement(DropdownContext.Provider, { value: { theme } }, children))
    );
  }
  renderNameOrPlaceholder() {
    const { name, placeholder, size } = this.props;
    const hasName = !!name;
    return /* @__PURE__ */ React.createElement(
      "span",
      {
        className: classNames([
          "dropdown__name",
          `dropdown__name--${size}`,
          { "dropdown__name--placeholder": !hasName }
        ])
      },
      hasName ? name : placeholder
    );
  }
};
Dropdown.defaultProps = {
  placeholder: "",
  disabled: false,
  size: "small" /* Small */,
  remainOpenOnSelect: false
};
__decorateClass([
  observable.ref
], Dropdown.prototype, "showingMenu", 2);
__decorateClass([
  action
], Dropdown.prototype, "toggleDropdown", 2);
__decorateClass([
  action
], Dropdown.prototype, "showDropdown", 2);
__decorateClass([
  action
], Dropdown.prototype, "hideDropdown", 2);
__decorateClass([
  action
], Dropdown.prototype, "hideDropdownFromOutside", 2);
Dropdown = __decorateClass([
  observer
], Dropdown);
export {
  Dropdown as default
};
